module.exports = __webpack_public_path__ + "img/shit_meta33matrix.bad60fd.png";